<template>
  <div class="proxy"
       style="width: 1px; height: 1px; overflow: hidden; display: none;">
    <span id="sidebarToggle"></span>
    <!--<span id="previous"></span>-->
    <!--<span id="next"></span>-->

    <input type="number" id="pageNumber" min="1" value="1">

    <div id="toolbar" class="hidden">
      <div id="toolbarViewer">
        <div id="toolbarViewerLeft"></div>
        <div id="toolbarViewerRight">
          <button id="presentationMode"
                  class="toolbarButton presentationMode hiddenLargeView"
                  title="Switch to Presentation Mode" tabindex="31"
                  data-l10n-id="presentation_mode">
            <span
              data-l10n-id="presentation_mode_label">Presentation Mode</span>
          </button>

          <button id="openFile" class="toolbarButton openFile hiddenLargeView"
                  title="Open File" tabindex="32" data-l10n-id="open_file">
            <span data-l10n-id="open_file_label">Open</span>
          </button>

          <a href="#" id="viewBookmark"
             class="toolbarButton bookmark hiddenSmallView"
             title="Current view (copy or open in new window)" tabindex="35"
             data-l10n-id="bookmark">
            <span data-l10n-id="bookmark_label">Current View</span>
          </a>

          <div class="verticalToolbarSeparator hiddenSmallView"></div>

          <button id="secondaryToolbarToggle" class="toolbarButton"
                  title="Tools" tabindex="36" data-l10n-id="tools">
            <span data-l10n-id="tools_label">Tools</span>
          </button>
        </div>
        <div id="toolbarViewerMiddle">

          <span id="scaleSelectContainer" class="dropdownToolbarButton">
                  <select id="scaleSelect" title="Zoom" tabindex="23"
                          data-l10n-id="zoom">
                    <option id="pageAutoOption" title="" value="auto"
                            selected="selected" data-l10n-id="page_scale_auto">Automatic Zoom</option>
                    <option id="pageActualOption" title="" value="page-actual"
                            data-l10n-id="page_scale_actual">Actual Size</option>
                    <option id="pageFitOption" title="" value="page-fit"
                            data-l10n-id="page_scale_fit">Page Fit</option>
                    <option id="pageWidthOption" title="" value="page-width"
                            data-l10n-id="page_scale_width">Page Width</option>
                    <option id="customScaleOption" title="" value="custom"
                            disabled="disabled" hidden="true"></option>
                    <option title="" value="0.5"
                            data-l10n-id="page_scale_percent"
                            data-l10n-args='{ "scale": 50 }'>50%</option>
                    <option title="" value="0.75"
                            data-l10n-id="page_scale_percent"
                            data-l10n-args='{ "scale": 75 }'>75%</option>
                    <option title="" value="1" data-l10n-id="page_scale_percent"
                            data-l10n-args='{ "scale": 100 }'>100%</option>
                    <option title="" value="1.25"
                            data-l10n-id="page_scale_percent"
                            data-l10n-args='{ "scale": 125 }'>125%</option>
                    <option title="" value="1.5"
                            data-l10n-id="page_scale_percent"
                            data-l10n-args='{ "scale": 150 }'>150%</option>
                    <option title="" value="2" data-l10n-id="page_scale_percent"
                            data-l10n-args='{ "scale": 200 }'>200%</option>
                    <option title="" value="3" data-l10n-id="page_scale_percent"
                            data-l10n-args='{ "scale": 300 }'>300%</option>
                    <option title="" value="4" data-l10n-id="page_scale_percent"
                            data-l10n-args='{ "scale": 400 }'>400%</option>
                  </select>
                </span>
        </div>
      </div>
      <div id="loadingBar">
        <div class="progress">
          <div class="glimmer">
          </div>
        </div>
      </div>
    </div>

    <div id="secondaryToolbar" class="secondaryToolbar hidden doorHangerRight">
      <div id="secondaryToolbarButtonContainer">
        <button id="secondaryPresentationMode" class="secondaryToolbarButton presentationMode visibleLargeView" title="Switch to Presentation Mode" tabindex="51" data-l10n-id="presentation_mode">
          <span data-l10n-id="presentation_mode_label">Presentation Mode</span>
        </button>

        <button id="secondaryOpenFile" class="secondaryToolbarButton openFile visibleLargeView" title="Open File" tabindex="52" data-l10n-id="open_file">
          <span data-l10n-id="open_file_label">Open</span>
        </button>

        <button id="secondaryPrint" class="secondaryToolbarButton print visibleMediumView" title="Print" tabindex="53" data-l10n-id="print">
          <span data-l10n-id="print_label">Print</span>
        </button>

        <button id="secondaryDownload" class="secondaryToolbarButton download visibleMediumView" title="Download" tabindex="54" data-l10n-id="download">
          <span data-l10n-id="download_label">Download</span>
        </button>

        <a href="#" id="secondaryViewBookmark" class="secondaryToolbarButton bookmark visibleSmallView" title="Current view (copy or open in new window)" tabindex="55" data-l10n-id="bookmark">
          <span data-l10n-id="bookmark_label">Current View</span>
        </a>

        <div class="horizontalToolbarSeparator visibleLargeView"></div>

        <button id="firstPage" class="secondaryToolbarButton firstPage" title="Go to First Page" tabindex="56" data-l10n-id="first_page">
          <span data-l10n-id="first_page_label">Go to First Page</span>
        </button>
        <button id="lastPage" class="secondaryToolbarButton lastPage" title="Go to Last Page" tabindex="57" data-l10n-id="last_page">
          <span data-l10n-id="last_page_label">Go to Last Page</span>
        </button>

        <div class="horizontalToolbarSeparator"></div>

        <button id="pageRotateCcw" class="secondaryToolbarButton rotateCcw" title="Rotate Counterclockwise" tabindex="59" data-l10n-id="page_rotate_ccw">
          <span data-l10n-id="page_rotate_ccw_label">Rotate Counterclockwise</span>
        </button>

        <div class="horizontalToolbarSeparator"></div>

        <button id="cursorSelectTool" class="secondaryToolbarButton selectTool toggled" title="Enable Text Selection Tool" tabindex="60" data-l10n-id="cursor_text_select_tool">
          <span data-l10n-id="cursor_text_select_tool_label">Text Selection Tool</span>
        </button>
        <button id="cursorHandTool" class="secondaryToolbarButton handTool" title="Enable Hand Tool" tabindex="61" data-l10n-id="cursor_hand_tool">
          <span data-l10n-id="cursor_hand_tool_label">Hand Tool</span>
        </button>

        <div class="horizontalToolbarSeparator"></div>

        <!--<button id="documentProperties" class="secondaryToolbarButton documentProperties" title="Document Properties…" tabindex="62" data-l10n-id="document_properties">-->
          <!--<span data-l10n-id="document_properties_label">Document Properties…</span>-->
        <!--</button>-->
      </div>
    </div>  <!-- secondaryToolbar -->

    <menu type="context" id="viewerContextMenu">
      <menuitem id="contextFirstPage" label="First Page"
                data-l10n-id="first_page"></menuitem>
      <menuitem id="contextLastPage" label="Last Page"
                data-l10n-id="last_page"></menuitem>
      <menuitem id="contextPageRotateCw" label="Rotate Clockwise"
                data-l10n-id="page_rotate_cw"></menuitem>
      <menuitem id="contextPageRotateCcw" label="Rotate Counter-Clockwise"
                data-l10n-id="page_rotate_ccw"></menuitem>
    </menu>

  </div>
</template>

<script>
  export default {
    name: 'AppProxy'
  }
</script>


// WEBPACK FOOTER //
// src/components/AppProxy.vue